import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../../../fc_link/fc_link';
import Poster from '../../../poster/poster';
import Eyebrow from '../../../eyebrow/eyebrow';
import { isPremium } from '../../../advertorial/advertorial';

export default function Featured(props) {
  const { config, metadata, cardEvent, loading } = props;
  const noImage = !get(metadata, 'featured_image.source');
  const textOnlyCard = metadata.allowTextOnly && noImage;
  const isPremiumArticle = isPremium(get(metadata, 'tags'));
  const setCardClasses = () => {
    const cardClasses = ['card', 'card--featured'];

    if (textOnlyCard) {
      cardClasses.push('card--text');
    }

    return cardClasses.join(' ');
  };
  const setPosterClasses = () => {
    const posterClasses = ['card__poster', 'card__poster--featured'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };

  return (
    <article className={setCardClasses()} onClick={event => cardEvent(event)}>
      <FCLink
        to={get(metadata, 'link')}
        title={get(metadata, 'title')}
        config={config}
        externalLink={
          get(metadata, 'external') || get(metadata, 'source') === 'external'
        }
        targetWindow={get(metadata, 'targetWindow')}
      >
        <Poster
          metadata={metadata}
          className={setPosterClasses()}
          generateClasses={false}
          loading={loading}
        />
        <div
          className={`card__text-wrapper card__text-wrapper--featured ${
            textOnlyCard ? 'card__text-wrapper--text-only' : ''
          }`}
        >
          <Eyebrow metadata={metadata} showIcon={isPremiumArticle} />
          <h2
            className={`card__title card__title--featured ${
              textOnlyCard ? 'card__title--only' : ''
            }`}
          >
            {get(metadata, 'title')}
          </h2>
          {isPremiumArticle && (
            <h3 className="card__deck card__deck--featured">
              {get(metadata, 'excerpt')}
            </h3>
          )}
        </div>
      </FCLink>
    </article>
  );
}

Featured.defaultProps = {
  cardEvent: () => {},
  loading: ''
};

Featured.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  cardEvent: PropTypes.func,
  loading: PropTypes.string
};
